import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { sendEventClick } from 'src/api/tracker';

import SectionContainer from 'src/containers/SectionContainer';
import BoxPopularCities from 'src/components/BoxPopularCities';
import Pagination from 'src/components/Pagination/PaginationWrapper';

const PopularCitiesContainer = ({ tiles }) => (
  <SectionContainer dataTestName="section-seo-city" title="Praca w miastach">
    <Pagination>
      {tiles.map(({ name, url, imageUrl, offersCount }, index) => (
        <BoxPopularCities
          key={`popular-city-${name}`}
          counter={offersCount}
          imageUrl={imageUrl}
          link={url}
          title={name}
          onClick={() => {
            sendEventClick('seobox_city', index);
          }}
        />
      ))}
    </Pagination>
  </SectionContainer>
);

PopularCitiesContainer.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProperties = ({ seoReducer }) => ({
  tiles: seoReducer.cities,
});

export default connect(mapStateToProperties)(PopularCitiesContainer);
